module.exports = __webpack_public_path__ + "static/media/Yoyo_3206.56e5db18.jpg";